import React, { useCallback } from "react";
import { QRCodeSVG } from 'qrcode.react';
import { 
  Container,
  Title,
  Description,
  ShortDescription,
  ContainerButtons,
  Button,
  QrRead,
  QRWrapper,
  ContainerTooltip,
  TooltipDescription,
  IconTooltip,
  TooltipTitle
} from "../../Styles/Container/ContainerQrStyle"
import { cancelOperation } from "../../shared/Constants/Constants"

const TITLES = {
  enabled: "Código QR leído",
  disabled: "Realiza biometría desde tu celular"
};

const DESCRIPTIONS = {
  enabled: "Tu autenticación está en proceso en tu celular. Completa la biometría para continuar.",
  disabled: "Escanea este código QR con la cámara del celular y completa la autenticación con biometría facial:"
};

const COLORS = {
  enabled: { background: "#FDDA23", text: "#2C2A29" },
  disabled: { background: "#D9DADD", text: "#97999B" }
};

const tooltipTitle= "Este QR es para activar Biometría facial en tu celular";
const tooltipdescription = "Solo se generan en la web de Bancolombia y se escanea con la cámara de tu celular, no con la app. No lo uses si lo recibes por mensaje, correo u otra página.";
const shortDescription = "Este código solo puede usarse una vez";
const shortDescriptionBig = "Esperando autenticación...";
const buttonTextBack = "Volver";

export function ContainerQr({urlMobile, isEnable, backFunction}) {
  const title = isEnable ? TITLES.enabled : TITLES.disabled;
  const description = isEnable ? DESCRIPTIONS.enabled : DESCRIPTIONS.disabled;
 
  
  const handleClose = useCallback(() => {
    backFunction(cancelOperation);
  }, [backFunction]);

  return (
      <>
          <ContainerTooltip>
              <IconTooltip/>
              <div>
                <TooltipTitle>{tooltipTitle}</TooltipTitle>
                <TooltipDescription>{tooltipdescription}</TooltipDescription>
              </div>
          </ContainerTooltip>
          <Container>
            <div> 
              <Title>{title}</Title>
              <Description>{description}</Description>
            </div>
            {!isEnable && (
              <QRWrapper>
                <QRCodeSVG value={urlMobile} />
                <ShortDescription>{shortDescription}</ShortDescription>
              </QRWrapper>
            )}
            {isEnable && (
              <div>
                <QrRead value={urlMobile} />
                <Title>{shortDescriptionBig}</Title>
              </div>
            )}
            <ContainerButtons>
                <Button onClick={handleClose} width={"100%"} color="#FFFFFF" border="solid 1px black">{buttonTextBack}</Button>
            </ContainerButtons>
          </Container>
      </>
    );
}